
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { writeLog } from '../../misc/logs';

@Component({
  selector: 'app-select-field',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.scss']
})
export class SelectFieldComponent implements OnInit, OnChanges {
  @Input() name = '';
  @Input() value: any;
  @Input() objectNameField: string;
  @Input() helpText: string;
  @Input() isObject: boolean = false;
  @Input() skipBlankItems: boolean = false;
  @Input() options: any[];
  @Input() required = false;
  @Input() loading = false;
  // allow empty or null values
  @Input() noEmptyValue = false;
  @Output() valueChange = new EventEmitter<any>();
  @Output() validityChange = new EventEmitter<boolean>();

  // selectedOption = 'Choose an item';
  fieldId = 'field_' + (Math.random() * 10000000);
  fieldValid: number = -1;
  isValid = false;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    // mandatory objectNameField
    if(!this.objectNameField && this.isObject) {
      throw('objectNameField is required on <app-select-field>');
    }

    // default item
    if(changes['noEmptyValue'] && changes['noEmptyValue'].currentValue && !this.value) {
      this.valueChanged(this.isObject ? this.options[0] : 0);
    } else if(this.value) {
      this.valueChanged(this.value);
    }

    // if(changes && changes['value'] && changes['value'].currentValue != null && changes['value'].previousValue != changes['value'].currentValue) {
    //   writeLog('input changes ....', this.value);
    //   this.makeChoice(changes['value'].currentValue, !changes['value'].firstChange);
    // }
  }

  // makeChoice(item, emit = true) {
  //   this.selectedOption = item ? item[this.objectNameField] : 'Choose an item';
  //   this.value = item;

  //   this.validate();

  //   if(emit) {
  //     this.valueChanged();
  //   }
  // }

  validate() {
    if(!this.required) {
      this.fieldValid = -1;
      this.isValid = true;
      return;
    }

    this.fieldValid = this.value != null ? (this.value != -1 ? 1 : 0) : 0;
    this.isValid = this.fieldValid == 1;
  }

  valueChanged(val) {
    writeLog('value changed', val);
    this.value = val;
    this.validate();
    this.valueChange.emit(this.value);
  }
}
